import React, {useMemo} from "react";
import {QuotesListsOrdersDataGridCellKeys, SalesOrdersListsOrdersDataGridCellKeys} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import {DataGridColumnAlignments, DataGridColumnTypes} from "../../../../../../../../../packages/data-grid";
import IconButton from "../../../../../../../../components/base/button/icon_button";
import {OpenInNew} from "@mui/icons-material";
import PartnerDataGrid, {useDataGridSavedState} from "../../../../../../../../containers/data-grid";
import useAccessLevels from "../../../../../../../../hooks/use-access-levels";
import {CircularProgress, SvgIcon} from "@mui/material";
import {ReactComponent as Printer} from '../../../../../../../../../assets/images/printer.svg'

const QuotesListViewOrdersTable = ({
                                       searchData,
                                       exportToCsv,
                                       data,
                                       dataGridSaveConfig,
                                       fetchingOrdersCustomer,
                                       navigateToInformationView,
                                       navigateToPrintView,
                                   }) => {
    const operatorAccessLevels = useAccessLevels();

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            ...(operatorAccessLevels.packages.sales.quoteInformation ? [
                {
                    name: QuotesListsOrdersDataGridCellKeys.navigate,
                    alignment: DataGridColumnAlignments.center,
                    type: DataGridColumnTypes.element,
                    pinned: true,
                    sortable: false,
                    pinnedToggleable: false,
                    resizable: false,
                    visibilityToggleable: false,
                    width: 0,
                },
                ...(operatorAccessLevels.packages.bizPrint.printQuote ? [
                    {
                        name: QuotesListsOrdersDataGridCellKeys.print,
                        alignment: DataGridColumnAlignments.center,
                        type: DataGridColumnTypes.element,
                        pinned: true,
                        sortable: false,
                        pinnedToggleable: false,
                        resizable: false,
                        visibilityToggleable: false,
                        width: 0,
                    },
                ] : []),
            ] : []),
            {
                title: "Order No",
                name: QuotesListsOrdersDataGridCellKeys.orderNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                pinned: true,
            },
            {
                title: "Customer",
                name: QuotesListsOrdersDataGridCellKeys.customer,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Order Date",
                name: QuotesListsOrdersDataGridCellKeys.orderDate,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.date,
            },
            {
                title: "Customer PO",
                name: QuotesListsOrdersDataGridCellKeys.customerPO,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Sales Person",
                name: QuotesListsOrdersDataGridCellKeys.salespersonNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Total Ordered",
                name: QuotesListsOrdersDataGridCellKeys.totalOrdered,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
                width: 120,
            },
            {
                title: "Status",
                name: QuotesListsOrdersDataGridCellKeys.status,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
        ], [operatorAccessLevels.packages.bizPrint.printQuote, operatorAccessLevels.packages.sales.quoteInformation])


    const [dataGridColumns, , , dataGridDensity] = useDataGridSavedState({
        columns: columns,
        version: dataGridSaveConfig.version,
        name: dataGridSaveConfig.name,
    });


    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return data?.map(order => ({
            key: order.id,
            data: order,
            cells: {
                [SalesOrdersListsOrdersDataGridCellKeys.navigate]:
                    <IconButton
                        color={'secondary'}
                        disabled={fetchingOrdersCustomer.includes(order.id)}
                        onClick={() => navigateToInformationView(order.customer, order.id)}

                    >
                        {
                            fetchingOrdersCustomer.includes(order.id)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <OpenInNew className='icon normal'/>
                        }
                    </IconButton>,
                [SalesOrdersListsOrdersDataGridCellKeys.print]:
                    <IconButton
                        color={'paper.secondary'}
                        disabled={fetchingOrdersCustomer.includes(order.id)}
                        onClick={() => navigateToPrintView(order.customer, order.id)}
                    >
                        {
                            fetchingOrdersCustomer.includes(order.id)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <SvgIcon className='icon medium' component={Printer}/>
                        }

                    </IconButton>,
                [QuotesListsOrdersDataGridCellKeys.orderNo]: order.orderNo,
                [QuotesListsOrdersDataGridCellKeys.customer]: order.customer?.name,
                [QuotesListsOrdersDataGridCellKeys.orderDate]: order.orderDate,
                [QuotesListsOrdersDataGridCellKeys.customerPO]: order.customerPO,
                [QuotesListsOrdersDataGridCellKeys.salespersonNo]: order.salespersonNo,
                [QuotesListsOrdersDataGridCellKeys.totalOrdered]: order.total,
                [QuotesListsOrdersDataGridCellKeys.status]: order.status,
            }
        }))
    }, [data, fetchingOrdersCustomer, navigateToInformationView, navigateToPrintView])

    return (
        <>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                columns={dataGridColumns}
                rows={dataGridRows}
                state={{
                    pagination: searchData.paginationInfo,
                    sortBy: searchData.orderBy,
                    loading: {state: searchData.loading},
                    density: dataGridDensity,
                }}
                hideFooterActions
                getExportInfo={exportToCsv}
                onSortByChanged={(_, current) => searchData.setOrderBy(current)}
                onCurrentPageChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
                onPageSizeChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
            />
        </>
    );
}

export default QuotesListViewOrdersTable;
